export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8438.82076852.jpg";